import React from 'react'
import MUIDataTable from 'mui-datatables'
import Loader from '../../common/Loader'
import Moment from 'react-moment'
import axios from 'axios'
import Swal from 'sweetalert2'
import Constant from '../../Constant'
import { Button } from '@material-ui/core'

class WegoUserReport extends React.Component {
  state = {
    country_list: [],
    data: [],

    isLoading: false,

    disabled: false,

    limit: 10,
    pageNumber: 0,

    bookingStatus: '',
    country: '',
    booking_date: '',
  }

  componentDidMount() {
    this.getBookingList()
    this.getCountries()
  }

  getCountries = async () => {
    await axios
      .get(Constant.getAPI() + '/multi-country/list-countries?show_all_countries=true', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name:
            localStorage.getItem('loged_In_role') === 'super-admin'
              ? ''
              : `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          this.setState({
            country_list: res.data.data,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  getBookingList = async () => {
    this.setState({
      isLoading: true,
      data: [],
    })

    await axios
      .get(Constant.getAPI() + `/reports/wego-report`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
        params: {
          country: this.state.country,
          status: this.state.bookingStatus,
          booking_date: this.state.booking_date,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            data: res.data?.data?.data,
            disabled: !res.data.data?.length > 0,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        })
      })
  }

  handleChange = (event) => {
    event.persist()

    this.setState({
      [event?.target?.name]: event?.target?.value,
    })
  }

  searchData = async () => {
    this.setState(
      {
        limit: 10,
        pageNumber: 0,
      },
      () => {
        this.getBookingList()
      }
    )
  }

  clearFilters = () => {
    this.setState({
      limit: 10,
      pageNumber: 0,
      bookingStatus: '',
      country: '',
      booking_date: '',
      data: [],
    })
  }

  render() {
    const columns = [
      {
        name: 'wego_click_id',
        label: 'Click ID',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'order_number',
        label: 'Order NO',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'cruise_name',
        label: 'CruiseName: English',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'customer_name',
        label: 'Customer Name',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'booking_date',
        label: 'Booking Date',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <div style={{ width: 80 }}>{value}</div>
          },
        },
      },
      {
        name: 'issue_date',
        label: 'Issue Date',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (issue_date) => {
            return (
              <div>
                <Moment format="DD/MM/YYYY">{issue_date}</Moment>
              </div>
            )
          },
        },
      },
      {
        name: 'payment_status',
        label: 'Payment status',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (payment_status) => {
            return (
              <div>
                {payment_status === true ? (
                  <span className="badge badge-pill badge-success">Success</span>
                ) : (
                  <span className="badge badge-pill badge-warning">In Progress</span>
                )}
              </div>
            )
          },
        },
      },
      {
        name: 'booking_status',
        label: 'Booking Status',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (booking_status) => {
            return (
              <>
                {['pending', 'cancelled'].includes(booking_status.toLowerCase()) ? (
                  <span className="badge badge-pill badge-warning">{booking_status}</span>
                ) : (
                  <span className="badge badge-pill badge-success">{booking_status}</span>
                )}
              </>
            )
          },
        },
      },
      {
        name: 'total_booking_amount',
        label: 'Total Booking Amount',
        options: {
          filter: true,
          sort: true,
        },
      },
    ]

    const options = {
      viewColumns: false,
      print: false,
      download: true,
      filter: false,
      search: false,

      selectableRows: 'none',
      textLabels: {
        body: {
          noMatch: this.state.isLoading ? <Loader open={this.state.isLoading} /> : 'Sorry, No Booking Data Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }

    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card card-border-default">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Booking Status</label>
                            <div className="col-sm-9">
                              <select
                                name="bookingStatus"
                                className="form-control"
                                value={this.state.bookingStatus}
                                onChange={this.handleChange}
                              >
                                <option value={''}>All</option>
                                <option value={'Pending'}>Pending</option>
                                <option value={'Successful'}>Successful</option>
                                <option value={'Cancelled'}>Cancelled</option>
                                <option value={'Confirmed'}>Confirmed</option>
                                <option value={'Postponed'}>Postponed</option>
                                <option value={'Incomplete'}>Incomplete</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Country</label>
                            <div className="col-sm-9">
                              <select
                                name="country"
                                className="form-control"
                                value={this.state.country}
                                onChange={this.handleChange}
                              >
                                <option value={''}>All</option>
                                {this.state.country_list.map((country) => (
                                  <option
                                    value={country.country_short_name}
                                    key={country.country_short_name}
                                  >
                                    {country.country_name_en + '/' + country.country_name_ar}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group row">
                            <label className="col-md-3 col-form-label">Booking Date</label>
                            <div className="col-md-9">
                              <input
                                type="date"
                                id="booking_date"
                                className="form-control"
                                value={this.state.booking_date}
                                name="booking_date"
                                onChange={this.handleChange}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <Button
                            variant="outlined"
                            color="primary"
                            onClick={this.clearFilters}
                            className="f-right ml-1"
                          >
                            Clear
                          </Button>
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={this.searchData}
                            className="f-right ml-1"
                          >
                            Search
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-sm-12">
                  <div className="dt-responsive table-responsive">
                    <MUIDataTable
                      title={'User Booking Report (Under 30 days registered users)'}
                      className="table-responsive"
                      data={this.state.data}
                      columns={columns}
                      options={options}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default WegoUserReport
